<template>
    <div class="main get-started">
        <div class="scroll flex">

            <div class="inner-container" >
              <div class="">
              <h1 class="layout-row flex-center">Get Started <info-icon>
	              Welcome on board, Here are a few quick shortcuts to get you started quickly.
              </info-icon> </h1>

	              <div class="top-buttons">
		              <big-button label="Use a template" has-arrow @click="$router.push({name:'GetStartedTemplates'})"
		                          :icon="require('@/assets/img/get-started/use-template.svg')"
		                          desc="Hit the ground running with one of our ready to use funnel templates" />
		              <big-button label="Blank funnel" :icon="require('@/assets/img/get-started/blank-funnel.svg')"
		                          desc="Create your own funnel from scratch" @click="newBlankFunnel=true" />
		              <add-new-funnel-popup v-if="newBlankFunnel" @close="newBlankFunnel=false" />
		              <big-button label="Redesign existing funnel" @click="openIntercom"
		                          :icon="require('@/assets/img/get-started/redesign-funnel.svg')"
		                          desc="Hire our team to redesign your existing eCommerce sales funnel" />
	              </div>

	              <h2>Here are some trending funnel templates to get you started</h2>

	              <loading v-if="loading" />
	              <div class="templates" v-if="templates">
		              <funnel-template-entry v-for="t in trendingTemplates" :key="t.id" :template="t"
		                                     @click="currentTemplate=t"/>
		              <funnel-template-entry empty @click="$router.push({name:'GetStartedTemplates'})" />
	              </div>

              <!-- Quick links -->
              <div v-if="false" style="margin-top: 60px;margin-right: 30px;margin-left: 30px;">
                <h1 style="margin-bottom: 20px;">Quick links</h1>
                <ul>
                  <li><external-link href="https://docs.funnelish.com/getting-started/step-1-add-your-funnel" label="How to add your first funnel?"></external-link></li>
                  <li><external-link href="https://docs.funnelish.com/getting-started/step-2-copy-your-tracking-code" label="How to copy and add your tracking code?"></external-link></li>
                  <li><external-link href="https://docs.funnelish.com/getting-started/step-3-turn-on-your-apps" label="How to turn on the apps?"></external-link></li>
                  <li><external-link href="https://docs.funnelish.com/faq/troubleshooting-issues" label="Troubleshooting common issues"></external-link></li>
                </ul>
              </div>
              </div>
            </div>
        </div>

	    <template-panel v-if="!!currentTemplate" :template="currentTemplate" @close="currentTemplate=null" />
    </div>
</template>

<script>

import MainRight from "@/components/MainRight";
import MainSearch from "@/components/MainSearch";
import DashboardBanner from "@/components/DashboardBanner";
import VButton from "@/components/base/v-button";
import ExternalLink from "@/components/base/external-link";
import BigButton from "@/components/base/big-button";
import FunnelTemplateEntry from "@/components/funnel-template-entry";
import API from "@/api";
import TemplatePanel from "@/views/get-started/template-panel";
import AddNewFunnelPopup from "@/views/funnels/add_new_funnel_popup";
import Loading from "@/components/Loading";
import InfoIcon from "@/components/base/info-icon";
export default {
    name: 'GetStarted',
	title:"Get started | Funnelish™",
    components: {
	    InfoIcon,
	    Loading,
	    AddNewFunnelPopup,
	    TemplatePanel,
	    FunnelTemplateEntry,
	    BigButton,
      ExternalLink,
      VButton,
      DashboardBanner,
      MainSearch,
      MainRight
    },
	mixins: [API],
	data: function() {
      return {
	      newBlankFunnel: false,
	      currentTemplate: null,
      	loading: false,
      	templates: [],
        username: "",
	      bannerOpened: false,
      }
  },
    computed: {
    	user() {
    		return this.$store.state.userInfo;
	    },
	    on_boarding(){
	    	return {
	    		title: `Hi, ${this.user.member.first_name || ''}`,
			    message: `Welcome on board, `+
					    `here are a few quick shortcuts to get you started quick.`
		    }
	    },
	    trendingTemplates(){
		    let ar = this.templates || [];
		    ar = ar.filter(x=>x.id!==1 && !x.deleted_at);
		    ar = ar.sort(function(a,b){
			    return new Date(b.created_at) - new Date(a.created_at);
		    });
		    return ar.slice(0,8);
	    },
      notificationsOpen() {
          return this.$store.state.notificationsOpen;
      },
    },
    methods: {
	    bannerClose: function(){
		    this.bannerOpened = !this.bannerOpened;
	    },
      openIntercom() {
	      Intercom('showNewMessage', 'Funnel Design Quote Request:\n\n' +
			      '1. How many pages you\'d like us to create?\n\n' +
			      '2. Please provide direct page(s) URLs to be cloned/redesigned?\n\n' +
			      '3. Any further details?\n');
      },
      notifToggle: function() {
          this.$store.dispatch('notificationsOpenToggle');
      },
    },
	async created() {
    	try {
    		this.loading = true;
    		this.templates = [];
		    this.templates = await this.api.wsteps.getFunnelTemplates();

	    } catch (e) {
    		this.$warn(e)
	    } finally {
		    this.loading = false;
	    }
	}
}
</script>
<style lang="scss" >
.get-started {
	.top-buttons {
		display: flex;
		flex-direction: row;
		align-items: start;
		margin-top: 20px;
		.big-button {
			flex-grow: 1;
			flex-basis: 0;
			margin-right: 20px;
			&:last-child {
				margin-right: 0;
			}
		}
	}
	h2 {
		margin-top: 30px;
		font-size: 18px;
		color: $black;
	}
	.templates {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
		grid-gap: 20px;
		margin-top: 20px;
	}
}
</style>
<style lang="scss" >
.get-started {
  .inner-container {
    padding: 30px;
  }
  .big-btn {
    cursor: pointer;
    padding: 20px 30px;
    border-radius: 20px;
    background: #F6F9FE;
    color: #636A7B;
    min-width: 200px;
    min-height: 100px;
    position: relative;
    width: auto;
    transition: .2s background ease-in-out;
    flex-direction: column;
    align-items: center;
    display: flex;
    span {
      display: block;
      margin-top: 20px;
    }
    svg path {
      fill: #C5C7D2;
    }
    &:hover {
      background: #EEF4FF;
      color: #252A32;
      svg path {
        fill: #4368E0;
      }
    }
  }
}

</style>
